import {
    Inventory,
    Supply,
} from "../../../../assets/svg-icons";

export const SS = {
    name: "Supply Sensing",
    route: null,
    permissions: [],
    shortName: "Supply Sensing",
    icon: Supply,
    child: {
        Inventory: {
            name: "Inventory",
            route: null,
            permissions: [],
            icon: Inventory,
            child: {
                "Sensed RP": {
                    name: "Sensed RP",
                    permissions: ["RSAI_VIEW"],
                    route: "/rs/inventory/sensing",
                },
            },
        },
    },
};